<template>
	<div>
		<HomeSlider />
	</div>
</template>

<script>
	import HomeSlider from './HomeSlider.vue'
	export default {
		components: {
			HomeSlider
		}
	}
</script>

<style lang="scss" scoped>
	
</style>